import { useTranslation } from 'react-i18next'
import PageHeader from '../../components/PageHeader'
import RolesPanel from '../../components/team/RolesPanel'

// Administración > Cargos: the Cargo dropdown every person picks from, with
// the discipline each one counts toward in Capacity's "Por mes" view. It
// lived in Engineering's Equipo page until people moved to Administración.
export default function AdminCargos() {
  const { t } = useTranslation('admin')
  return (
    <div className="p-8 space-y-4">
      <PageHeader title={t('cargos.title')} subtitle={t('cargos.subtitle')} />
      <RolesPanel inline />
    </div>
  )
}
